import { Model } from './model';
import { Transform, Type } from 'class-transformer';
import { ApPortalAccount } from './ap_portal_account';
import { Partner } from './partner';

export enum ApPortalProvider {
  ALBERTSONS = 'albertsons',
  CVS = 'cvs',
  CVS_SAP = 'cvs_sap',
  CVS_IMAGE_SILO = 'cvs_image_silo',
  HEB = 'heb',
  HEB_SIDM = 'heb_sidm',
  KEHE = 'kehe',
  KROGER_CLAIMTRAX = 'kroger_claimtrax',
  KROGER_SUPPLIER_CONNECT = 'kroger_supplier_connect',
  KROGER_VERIGON = 'kroger_verigon',
  MEIJER = 'meijer',
  TARGET = 'target',
  WALMART = 'walmart',
  WALMART_HIGHRADIUS = 'walmart_highradius',
  // ARIBA = 'ariba',
  // COUPA = 'coupa',
  // TAULIA = 'taulia',
}

export const ApPortalNameMap = {
  cvs: 'CVS Health',
  cvs_sap: 'CVS SAP',
  cvs_image_silo: 'CVS Image Silo',
  heb: 'HEB AP-AR',
  heb_sidm: 'HEB Supplier IDM',
  kehe: 'KeHE Connect',
  kroger_claimtrax: 'Kroger ClaimTrax',
  kroger_supplier_connect: 'Kroger Supplier Connect',
  kroger_verigon: 'Kroger Verigon',
  meijer: 'meijer VendorNet',
  target: 'Target AR',
  walmart: 'Walmart RetailLink',
  walmart_highradius: 'Walmart HighRadius',
};

export const ApPortalOperationNameMap: Record<string, string> = {
  target_payments: 'Payments',
  target_credit_debit: 'Credit/Debit',
  target_contracts: 'Contracts',
  target_otif: 'OTIF',
};

export enum ReportFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export class ApPortal extends Model {
  @Type(() => Partner)
  partner: Partner | null;

  @Type(() => ApPortalAccount)
  account: ApPortalAccount | null;

  id: string;

  name: string;

  provider: string;

  partner_id: string;

  account_id: string;

  account_key?: string;

  customer_name?: string | null;

  customer_identifier?: string | null;

  report_email?: string;

  is_invoice_submission_enabled?: boolean;

  is_report_download_enabled?: boolean;

  invoice_submission_guidelines?: string;

  report_frequency?: ReportFrequency;

  status?: string;

  get providerName() {
    return (ApPortalNameMap[this.provider] || this.provider) as string;
  }
}
